import {
  ControlGroup,
  type ControlGroupCaptionProps,
  type ControlGroupLabelProps,
  type ControlGroupProps,
  type ControlGroupValidationProps,
} from '../ControlGroup'

export type CheckboxGroupProps = ControlGroupProps
export type CheckboxGroupLabelProps = ControlGroupLabelProps
export type CheckboxGroupCaptionProps = ControlGroupCaptionProps
export type CheckboxGroupValidationProps = ControlGroupValidationProps

export const CheckboxGroup = ControlGroup
